// React & Libraries
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Utilities & Helpers
import checkPermissions from "../../global-functions/checkPermissionsFunc";
import { handleDeleteEntity } from "../../../utils/deleteHelper";

// Redux Actions - Countries, States, Cities
import { getCountriesFunc } from "../../../store/custom-actions/countries-actions/GetContriesSlicer";
import { getStatesFunc } from "../../../store/custom-actions/states-actions/GetStatesSlicer";
import { getCitiesFunc } from "../../../store/custom-actions/cities-actions/GetCitiesSlicer";
import { deleteCityFunc } from "../../../store/custom-actions/cities-actions/DeleteCitySlicer";

// Custom Forms
import NewCityForm from "../../custom-forms/cities/NewCityForm";
import UpdateCityForm from "../../custom-forms/cities/UpdateCityForm";

// UI Components
import LoadingScreen from "../../components/loading-screen/LoadingScreen";
import PageTitle from "../../layouts/PageTitle";
import SearchBox from "../../components/ui/SearchBox";
import Table from "../../components/ui/Table";
import Pagination from "../../components/ui/Pagination";
import SelectBox from "../../components/ui/SelectBox";


export default function CitiesPage() {
  const { t } = useTranslation();
  const { loading: getCitiesLoading, data: citiesData } = useSelector(state => state.getCitiesSlicer)
  const { loading: deleteCityLoading } = useSelector(state => state.deleteCitySlicer)
  const { loading: getCountriesLoading, data: countriesData } = useSelector(state => state.getCountriesSlicer);
  const { loading: getStatesLoading, data: statesData } = useSelector(state => state.getStatesSlicer);
  const [citiesList, setCitiesList] = useState([]);
  const [showNewCityForm, setShowNewCityForm] = useState();
  const [showUpdateForm, setShowUpdateForm] = useState();
  const [cityWhichUpdate, setCityWhichUpdate] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [countryFilterValue, setCountryFilterValue] = useState("");
  const [stateFilterValue, setStateFilterValue] = useState("");
  const dispatch = useDispatch();
  const getCountries = () => {
    dispatch(getCountriesFunc())
      .then((result) => {
        console.log(result)
        setCountryFilterValue(result?.payload[0]?.id)
      })
  }
  useEffect(() => {
    getCountries();
  }, [])

  useEffect(() => {
    if (countryFilterValue !== "") {
      const getStates = () => {
        dispatch(getStatesFunc(`?country_id=${countryFilterValue}`))
          .then((result) => {
            setStateFilterValue(result?.payload[0]?.id)
          })
      }
      getStates();
    }
  }, [countryFilterValue]);
  useEffect(() => {
    citiesData && setCitiesList(citiesData);
    citiesData && (jobData.current = citiesData.slice(
      activePag.current * sort,
      (activePag.current + 1) * sort
    ));
  }, [citiesData]);

  const filterFunc = () => {
    const api = `?${countryFilterValue !== "" ? `country_id=${countryFilterValue}` : ""}${searchValue !== "" ? `&search=${searchValue}` : ""}&${stateFilterValue !== "" ? `state_id=${stateFilterValue}` : ""}`;
    dispatch(getCitiesFunc(api))
  }
  useEffect(() => {
    if (countryFilterValue && stateFilterValue) {
      filterFunc();
    }
  }, [countryFilterValue, stateFilterValue])
  const sort = 20;

  const activePag = useRef(0);
  const jobData = useRef(
    citiesList.slice(
      activePag.current * sort,
      (activePag.current + 1) * sort
    )
  );
  const onClick = (i) => {
    activePag.current = i;
    jobData.current = citiesList.slice(
      activePag.current * sort,
      (activePag.current + 1) * sort
    );
  };

  const handleDeleteItem = (id, entityName = "") => {
    handleDeleteEntity({
      id,
      entityName: entityName,
      deleteFunc: deleteCityFunc,
      dispatch,
      refetchFunc: getCitiesFunc,
      t,
    });
  };

  return (
    <>
      <PageTitle motherMenu={"Dashboard"} activeMenu={"Cities"} />
      {
        (
          <div className="col-12">
            <div className="card">
              <div className="card-header row">
                <div className="col-6">
                  <SearchBox
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                    onSearch={() => filterFunc()}
                  />
                </div>
                <div className="col-6 text-end">
                  {
                    checkPermissions(
                      "create addresses",
                      <Link
                        to={"#"}
                        className="btn btn-primary btn-md"
                        onClick={() => [
                          setShowNewCityForm(true)
                        ]}
                      >{t("Create")}</Link>
                    )
                  }
                </div>
                <div className="col-6">
                  <div className="mt-3">
                    <SelectBox
                      value={countryFilterValue}
                      onChange={(e) => setCountryFilterValue(e.target.value)}
                      loading={getCountriesLoading}
                      data={countriesData}
                      placeholder={t("Choose Country")}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="mt-3">
                    <SelectBox
                      value={stateFilterValue}
                      onChange={(e) => setStateFilterValue(e.target.value)}
                      loading={getStatesLoading}
                      data={statesData}
                      disabled={!countryFilterValue}
                      placeholder={t("Choose State")}
                    />
                  </div>
                </div>



              </div>
              <div className="card-body">
                <div className="w-100 table-responsive">
                  <div id="example_wrapper" className="dataTables_wrapper">
                    <Table
                      showIndex={true}
                      startIndex={activePag.current * sort}
                      columns={[
                        { header: t("Name"), render: (row) => row.name },
                        { header: t("Code"), render: (row) => row.code },
                        {
                          header: t("Status"),
                          render: (row) => (
                            <span className={`relative text-sm rounded-lg text-white ${row.active == 1 ? "bg-green-500" : "bg-red-500"} p-1`}>
                              {row.active == 1 ? t("Active") : t("Not Active")}
                            </span>
                          )
                        },
                        { header: t("State"), render: (row) => row?.state?.name || "-" },
                        { header: t("Country"), render: (row) => row?.country?.name || "-" },
                      ]}
                      data={jobData.current}
                      loading={getCitiesLoading}
                      actions={(city) => (
                        <>
                          {checkPermissions(
                            "update addresses",
                            <Link
                              to="#"
                              className="btn btn-primary shadow btn-xs sharp me-1"
                              onClick={() => {
                                setShowUpdateForm(true);
                                setCityWhichUpdate(city);
                              }}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                          )}
                          {checkPermissions(
                            "delete addresses",
                            <Link
                              to="#"
                              className="btn btn-danger shadow btn-xs sharp"
                              onClick={() => handleDeleteItem(city.id, city.name)}
                            >
                              <i className="fa fa-trash"></i>
                            </Link>
                          )}
                        </>
                      )}
                    />
                    <Pagination
                      totalItems={citiesList.length}
                      currentPage={activePag.current}
                      perPage={sort}
                      onPageChange={(page) => onClick(page)}
                      t={t}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
      <LoadingScreen loading={deleteCityLoading} />
      <NewCityForm
        show={showNewCityForm}
        onHide={() => setShowNewCityForm(false)}
      />
      <UpdateCityForm
        show={showUpdateForm}
        onHide={() => setShowUpdateForm(false)}
        city={cityWhichUpdate}
      />
    </>
  )
}